<template>
  <div class="drag-uploader">
    <div class="upload">
      <b-alert variant="danger" :show="dismissCountDown" dismissible @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
        There were error with some file/s
      </b-alert>
      <div v-if="files.length" class="mb-3">
        <div v-for="(file, index) in files" :key="index" class="mr-3 d-inline-block" style="position: relative">
          <span class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="deleteUploaded(index)">×</span>
          <img :src="file.response.full_path" alt="" style="width: 100px; height: auto;" v-if="file.response && file.response.full_path">
        </div>
      </div>
      <div v-else>
        <div class="text-center p-5" v-if="!minimal">
          <h4>Drop files anywhere to upload<br/>or</h4>
          <label for="file" class="btn btn-secondary py-1 px-2"><font-awesome-icon icon="paperclip" size="1x" /> Select Files</label>
        </div>
      </div>

      <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
        <h3>Drop files to upload</h3>
      </div>

      <div>
        <file-upload
          extensions="gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp"
          :post-action="$appConfig.api.baseUrl + 'files'"
          :headers="authHeaders"
          :multiple="true"
          :drop="true"
          :drop-directory="false"
          v-model="files"
          @input-file="inputFile"
          ref="upload">
          <b-button variant="secondary" class="py-1 px-2" v-if="files.length || minimal">
            <font-awesome-icon icon="paperclip" size="1x" />
          </b-button>
        </file-upload>
      </div>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import vueAuthInstance from '@/services/auth'

export default {
  name: 'GenericPictureUpload',
  components: {
    FileUpload
  },
  props: {
    minimal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: [],
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  computed: {
    authHeaders() {
      return {
        'Authorization': 'Bearer ' + vueAuthInstance.getToken()
      }
    }
  },
  watch: {
    files(newVal, oldVal) {
      this.$emit('updated', this.files)
    }
  },
  methods: {
    inputFile(newFile, oldFile, prevent) {
      // Catch upload error
      if (newFile.active === false && newFile.success === false) {
        if (newFile.error) {
          this.files.splice(this.files.findIndex(x => x.file.name === newFile.name), 1)
          this.showAlert()
        }
      }
      // Automatic upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    deleteUploaded(index) {
      this.files.splice(index, 1)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>

<style lang="scss">
.drag-uploader {
  label.btn {
    margin-bottom: 0;
    margin-right: 1rem;
  }
  .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
    h3 {
      margin: -.5em 0 0;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
      font-size: 40px;
      color: #fff;
      padding: 0;
    }
  }
}
</style>
